/**
 * Cookie
 */
app.factory("CookieService",
	["$window", function($window) {
		return $window.Cookies;
	}]
);
